import { defineComponent as h, useTemplateRef as d, computed as g, createElementBlock as w, openBlock as T, mergeProps as v, unref as x } from "vue";
import { htmlFromMarkdown as y } from "@scalar/code-highlight";
import { useBindCx as k } from "@scalar/use-hooks/useBindCx";
const B = ["innerHTML"], C = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "ScalarMarkdown",
  props: {
    value: {},
    withImages: { type: Boolean, default: !1 },
    withAnchors: { type: Boolean, default: !1 },
    transform: { type: Function },
    transformType: {},
    clamp: {},
    anchorPrefix: {}
  },
  setup(e, { expose: o }) {
    const { cx: i } = k(), c = d("div");
    o({ el: c });
    const l = (t) => {
      var n, a, m;
      if (!e.withAnchors)
        return ((n = e.transform) == null ? void 0 : n.call(e, t)) || t;
      const r = (((m = (a = t.children) == null ? void 0 : a[0]) == null ? void 0 : m.value) || "").toLowerCase().replace(/\s+/g, "-"), u = e.anchorPrefix ? `${e.anchorPrefix}/description/${r}` : r;
      return t.data = {
        hProperties: {
          id: u
        }
      }, e.transform ? e.transform(t) : t;
    }, f = g(() => y(e.value ?? "", {
      removeTags: e.withImages ? [] : ["img", "picture"],
      transform: e.withAnchors && e.transformType === "heading" ? l : e.transform,
      transformType: e.transformType
    }));
    return (t, s) => (T(), w("div", v({ ref: "div" }, x(i)("markdown", { "line-clamp-(--markdown-clamp)": !!t.clamp }), {
      style: { "--markdown-clamp": t.clamp },
      innerHTML: f.value
    }), null, 16, B));
  }
});
export {
  C as default
};
